<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-2">
                        <br />
                        <a :href="'/card/detail/' + card.id" class="link">
                            <i class="bi bi-chevron-left"></i>
                        </a>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <h5>好みのカードを作成</h5>
                    </div>
                    <div class="col-2 text-end">
                        <br />
                        <a style="color:#cdcdcd" v-if="is_owner" @click="rmCard()">削除</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <div class="container" style="padding-top:70px;">
                <br>
                <div class="row">
                    <div class="col">
                        <div style="font-size:12px;color:#5538EE;padding-top:10px;">カード名</div>
                        <input type="text" class="luna-form-control" id="user_name" name="user_name" placeholder="入力する"
                            v-model="name" />
                        <p class="error-text" id="error-text_my_like" v-if="is_text_name"><i
                                class="bi bi-x-circle-fill"></i>文字数がオーバーしています（最大50文字）
                        </p>
                        <br>
                        <div style="font-size:12px;color:#5538EE;padding-top:10px;">カテゴリー</div>
                        <v-select name="sex" :options="categorys" v-model="category" placeholder="選択してください">
                        </v-select>
                        <br>
                        <div style="font-size:12px;color:#5538EE;padding-top:10px;">サムネイル</div>
                        <div>
                            <croppa v-model="myCroppa" :width="200" :height="200" placeholder="" :placeholder-font-size="0"
                                :disabled="false" :prevent-white-space="false" :show-remove-button="true"
                                :initial-image="initialImage" accept=".jpeg,.jpg,.png"
                                @file-type-mismatch="onFileTypeMismatch">
                                <img slot="placeholder" src="/images/Group13197.png" height="200">
                            </croppa>
                        </div>
                        <p class="error-text" id="error-text_my_like" v-if="is_image"><i
                                class="bi bi-x-circle-fill"></i>画像を設定してください
                        </p>
                        <div>
                            <button type="button" class="btn btn-luna" style="font-size: 18px;"
                                @click="myCroppa.rotate()"><i class="bi bi-arrow-clockwise"></i>
                            </button>
                        </div>
                        <br>
                        <div style="color:red;font-size:14px;padding:15px;">
                            <b>
                                ※ 明らかに卑猥なイメージやわいせつな行為を明示する写真等を登録された場合は、運営が画像を差し替える場合があります。
                            </b>
                        </div>
                        <br>
                        <div class="text-center">
                            <button type="button" class="btn btn-luna" style="font-size: 18px; padding: 12px 100px"
                                @click="setCard()"
                                v-if="is_owner && is_entry && name != '' && category != null && (this.myCroppa.generateDataUrl() != '')">
                                保存する
                            </button>
                            <button type="button" class="btn btn-luna-d" style="font-size: 18px; padding: 12px 100px"
                                v-else>
                                保存する
                            </button>
                        </div>
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CARD_REGISTRATION_STATE } from '../../constants/cardRegistrationState';

export default {
    data() {
        return {
            myCroppa: {},
            initialImage: null,
            user: [],
            card: [],
            name: "",
            url: "",
            categorys: [],
            category: null,
            is_entry: true,
            is_text_name: false,
            is_image: false,
            is_owner: false,
        };
    },
    methods: {
        onFileTypeMismatch(file) {
            alert('jpg, gif, png　形式でアップして下さい。')
        },
        async init() {
            await axios.get("/api/auth/user/get")
                .then(
                    () => {
                        this.fetchUsers()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/get/me")
                .then((response) => {
                    this.user = response.data.user
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchCard() {
            await axios.get("/api/card/get/" + this.$route.params['cid'])
                .then((response) => {
                    const btnType = response.data.btn_type
                    // 作成者以外は編集させず詳細画面へ戻す（詳細画面の「編集」リンクと同じ条件）
                    if (btnType != CARD_REGISTRATION_STATE.OWNER_REGISTERED && btnType != CARD_REGISTRATION_STATE.OWNER_REGISTERABLE) {
                        window.location.href = "/card/detail/" + this.$route.params['cid']
                        return
                    }
                    this.is_owner = true

                    this.card = response.data.card
                    this.name = this.card.name
                    let _id = response.data.category.id
                    let _name = response.data.category.name

                    let c = { value: _id, label: _name }

                    this.category = c

                    var image = new Image()
                    // Notice: it's necessary to set "crossorigin" attribute before "src" attribute.
                    image.setAttribute('crossorigin', 'anonymous')
                    image.src = this.card.thumbnail_image

                    this.initialImage = image
                    this.myCroppa.refresh()
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの取得に失敗しました")
                    }
                })
        },
        async fetchCategory() {
            await axios.get("/api/card/category/list")
                .then((response) => {
                    let c = []
                    response.data.categorys.forEach(function (category) {
                        c.push({
                            value: category.id,
                            label: category.name,
                        })
                    })
                    this.categorys = c
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カテゴリーの取得に失敗しました")
                    }
                })
        },
        async setCard() {
            if (this.myCroppa.generateDataUrl() != "") {
                this.is_image = false
                this.is_entry = false
                await axios.post("/api/card/mod", {
                    cid: this.card.id,
                    name: this.name,
                    category: this.category.value,
                    icon_image: this.myCroppa.generateDataUrl(),
                })
                    .then((response) => {
                        if (!alert('カード情報を更新しました。')) {
                            window.location.href = "/card/detail/" + this.card.id
                        }
                    })
                    .catch(function (error) {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            window.location.href = "/error"
                        }
                    })
            }
            else {
                this.is_image = true
            }
        },
        async rmCard() {
            await axios.get("/api/card/rm/" + this.card.id)
                .then((response) => {
                    window.location.href = "/card"
                })
                .catch(function (error) {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        window.location.href = "/error"
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.init()
                            this.fetchCategory()
                            this.fetchCard()
                        })
                    .catch(function (error) {
                        window.location.href = "/error"
                    })
            }
            else {
                this.init()
                this.fetchCategory()
                this.fetchCard()
            }
        }
        else {
            this.init()
            this.fetchCategory()
            this.fetchCard()
        }
    },
    watch: {
        name: function (newVal) {
            if (newVal == null) {
                this.is_text_name = false;
            }
            else if ([...newVal].length > 50) {
                this.is_text_name = true;
            } else {
                this.is_text_name = false;
            }
        },
    },
};
</script>
<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
